import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { latLng, tileLayer } from 'leaflet';


import { ChartType, Stat, Chat, Transaction } from './dashboard.model';

import { statData, revenueChart, salesAnalytics, sparklineEarning, sparklineMonthly, chatData, transactions, spark3Chart, spark2Chart, spark1Chart } from './data';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Router } from '@angular/router';
import { ParameterService } from 'src/app/shared/service/params/param';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: false,

  styleUrls: ['./dashboard.component.scss']
})

/**
 * Dashboard Component
 */
export class DashboardComponent implements OnInit {

  term: any;
  chatData: Chat[];
  transactions: Transaction[];
  statData: Stat[];
  statistique:any = [];
  statistiqueMorguier:any = [];
  reference:any;
  accesCode:any;
  
  constructor(
    public formBuilder: UntypedFormBuilder,
   private parameterService:ParameterService,
    //private morguierService:MorguierService,
    private localStorage:LocalStorageService,
    private router:Router,

  ) {
    this.reference = this.localStorage.getUsers().data;
    console.log(" this.reference", this.reference);
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  revenueChart: ChartType;
  salesAnalytics: ChartType;
  sparklineEarning: ChartType;
  sparklineMonthly: ChartType;
  spark1: any;
  spark2: any;
  spark3: any;
  simplePieChart: any;
  

  ngOnInit(): void {
    this.getStatistiqueDashboad();

    
     
  }



  getStatistiqueDashboad(){
    this.parameterService.getDashboard(this.reference.reference).subscribe(
      (response:any)=>{
        this.statistique = response.data;
            console.log("la reponse du webservice", this.statistique);
            this.updateChart();

      },
      (error)=>{
        console.log("une erreur est survenu",error);

      }
    )
  }
  updateChart() {
    if (!this.statistique) return;
  
    const labelsMap: { [key: string]: string } = {
      cooperatives: "Coopératives",
      admins_valides: "Administrateurs Validés",
      admins_rejetes: "Administrateurs Rejetés",
      admins_attente: "Administrateurs en Attente",
      agents: "Agents",
      demandes: "Demandes",
      nbre_hommes: "Nombre d'Hommes",
      nbre_femmes: "Nombre de Femmes",
    };
  
    // Récupérer uniquement les clés valides avec des valeurs définies
    const filteredKeys = Object.keys(labelsMap).filter(key => this.statistique[key] !== undefined);
    const labels = filteredKeys.map(key => labelsMap[key]);
    const totalMontants = filteredKeys.map(key => this.statistique[key]);
  
    const colors = ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043', '#AB47BC', '#26A69A', '#D4E157', '#FFB300'];
  
    this.simplePieChart = {
      series: totalMontants,
      chart: {
        type: 'pie',
        width: '100%',
        height: 420,
        
        // Meilleure adaptabilité
      },
      labels: labels,
      legend: {
        position: 'top',
        horizontalAlign: 'center',
      },
      colors: colors.slice(0, labels.length),
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: '100%',
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    };
  }
  
  
  routerForDepot(){
    console.log("come");

    this.router.navigate(['/morguier/depots_corps'])
  }
}
